import { ArrayUtil } from 'helper-util';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  isNavbarOpen: boolean;
  toggleNavBar: () => void;
  label: string;
  icon: any;
  activeMenu: string;
  setActiveMenu: any;
  subMenu: [any];
  path: string;
}

const MenuOption: React.FC<Props> = ({
  isNavbarOpen,
  toggleNavBar,
  label,
  icon,
  activeMenu,
  setActiveMenu,
  subMenu,
  path,
}) => {
  const navigate = useNavigate();
  const currentLocation = useLocation();

  useEffect(() => {
    if (!isNavbarOpen) {
      setActiveMenu(null);
    }
  }, [isNavbarOpen]);

  const toggleSubMenu = () => {
    if (activeMenu === label) {
      setActiveMenu(null);
    } else {
      setActiveMenu(label);
    }

    if (!subMenu.length) {
      navigate(path);
      toggleNavBar();
    }
  };

  return (
    <>
      <div
        onClick={() => {
          if (!isNavbarOpen) toggleNavBar();
          toggleSubMenu();
        }}
        className={`nav-item ${!ArrayUtil.isEmpty(subMenu) && 'has-submenu'} ${activeMenu === label ? 'active' : ''}`}
        title={label}
      >
        <span>{icon}</span>
        <span className="ml-10 f-14 text-uppercase overflow-ellipsis max-width-120 pr-2">
          {label}
        </span>
      </div>
      {!ArrayUtil.isEmpty(subMenu) && (
        <div className={`nav-item submenu ${activeMenu === label ? 'active' : ''}`} title={label}>
          {subMenu.map((sm) => (
            <div
              key={sm.path}
              className={`sub-item d-block overflow-ellipsis max-width-160 ${currentLocation.pathname === sm.path ? 'active' : ''}`}
              title={sm.labelTooltip || sm.label}
              onClick={() => {
                navigate(sm.path);
                toggleNavBar();
              }}
            >
              {sm.isAggregate ? <span className="pl-3">{sm.label}</span> : sm.label}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MenuOption;
